(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BAB-intro"] && !Shopify.designMode) return;
  try {
    

setTimeout(() => {
    document.querySelector('#rbz-zipcode-section').value = localStorage.getItem('custom_postal_code');
    document.querySelectorAll('#rbz-email-section')[0].value = localStorage.getItem('custom_email_address')
}, 500);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["join-the-gut-gang"] && !Shopify.designMode) return;
  try {
    

document.querySelector('.btn_link').addEventListener('click', function(e){
  e.preventDefault();
  localStorage.setItem('custom_postal_code', document.querySelector('#rbz-zipcode-section').value);
  localStorage.setItem('custom_email_address', document.querySelectorAll('#rbz-email-section')[1].value);
  window.location.href = this.getAttribute('href'); 
})


  } catch(e) { console.error(e); }
})();
})();
